import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=a46ca04c&"
import script from "./bind-phone.vue?vue&type=script&lang=ts&"
export * from "./bind-phone.vue?vue&type=script&lang=ts&"
import style0 from "./bind-phone.vue?vue&type=style&index=0&lang=less&"
import style1 from "./bind-phone.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports